/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import PageContentContainer from "../../Container/PageContentContainer";
import Grid from "@mui/material/Grid";
import advocard from "../../../assets/img/partner/advocard_300px_light.png";
import arag from "../../../assets/img/partner/arag_300px_light.png";
import huk from "../../../assets/img/partner/huk-coburg_300px_light.png";
import wbs from "../../../assets/img/partner/WBS_grey.png";
import nrv from "../../../assets/img/partner/logo_nrv.svg";
import { partnersSectionStyles } from "./PartnersSectionStyle";
import { Box } from "@mui/material";

const PartnersSection = () => {
  return (
    <Box sx={partnersSectionStyles.partnerSectionContainer}>
      <PageContentContainer>
        <Grid
          container
          spacing={4}
          sx={{
            justifyContent: "space-evenly",
            alignItems: "center"
          }}>
          <Grid
            size={{
              md: 2,
              xs: 6
            }}>
            <Box sx={partnersSectionStyles.logoContainer}>
              <Box component={"img"} src={advocard} sx={partnersSectionStyles.logo} alt={"Logo Advocard"} />
            </Box>
          </Grid>
          <Grid
            size={{
              md: 2,
              xs: 6
            }}>
            <Box sx={partnersSectionStyles.logoContainer}>
              <Box component={"img"} src={arag} sx={partnersSectionStyles.logo} alt={"Logo Arag"} />
            </Box>
          </Grid>
          <Grid
            size={{
              md: 2,
              xs: 6
            }}>
            <Box sx={partnersSectionStyles.logoContainer}>
              <Box component={"img"} src={huk} sx={partnersSectionStyles.logo} alt={"Logo HUK"} />
            </Box>
          </Grid>
          <Grid
            size={{
              md: 2,
              xs: 6
            }}>
            <Box sx={partnersSectionStyles.logoContainer}>
              <Box component={"img"} src={wbs} sx={partnersSectionStyles.logo} alt={"Logo WBS Legal"} />
            </Box>
          </Grid>
          <Grid size={{ md: 2, xs: 6 }}>
            <Box sx={partnersSectionStyles.logoContainer}>
              <Box component={"img"} src={nrv} sx={partnersSectionStyles.logo} alt={"Logo NRV"} />
            </Box>
          </Grid>
        </Grid>
      </PageContentContainer>
    </Box>
  );
};

export default PartnersSection;
